import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 30px 0 10px;
  position: relative;

  &.compact {
    padding: 0 0;
  }

  h2 {
    font-size: 40px;
  }

  p {
    text-align: center;
    font-size: 20px;

    strong {
      background-color: palevioletred;
      color: black;
      font-weight: 300;
      padding: 0 5px;
      margin: 0 5px;
      border-radius: 5px;
    }
  }
`;

export const Actions = styled.div`
  position: absolute;
  top: 40px;
  right: 0;
`;
